import { setHtmlPageLang } from '@/plugins/vueI18n/helper';
import { LocaleType } from '@/store/locale';
import { useI18n } from 'vue-i18n';
const setI18nLanguage = (locale: LocaleType) => {
    setHtmlPageLang(locale);
};

export const useLocale = () => {
    const { locale, setLocaleMessage } = useI18n();
    const changeLocale = async (localeType: LocaleType) => {
        const langModule = await import(`../locales/${localeType}.ts`);
        setLocaleMessage(localeType, langModule.default);
        locale.value = localeType;
        setI18nLanguage(localeType);
    };

    return {
        changeLocale,
    };
};
